<!-- src/components/ui/EmptyState.vue — consistent empty state (icon + message + optional action) -->
<script>
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "ri-inbox-line" },
    title: { type: String, default: "Nothing here yet" },
    text: { type: String, default: "" },
  },
};
</script>

<template>
  <div class="text-center text-muted py-5">
    <div class="avatar-md mx-auto mb-3">
      <span class="avatar-title bg-light text-muted rounded-circle fs-1">
        <i :class="icon"></i>
      </span>
    </div>
    <h6 class="mb-1 text-body">{{ title }}</h6>
    <p v-if="text" class="mb-3">{{ text }}</p>
    <slot></slot>
  </div>
</template>
